export const DISTRIBUTE_AMOUNT = Number(
  process.env.NEXT_PUBLIC_DISTRIBUTE_AMOUNT ?? "10000"
);

export type NetworkType = "testnet" | "mainnet";
export const networkType: NetworkType =
  (process.env.NEXT_PUBLIC_NETWORK_TYPE as NetworkType) || "testnet";

export const BASE_SEPOLIA_HTTP_RPC_URL =
  "https://base-sepolia.g.alchemy.com/v2/6GKxbi8Ws08Hj9DpzoG0w";
export const BASE_MAINNET_HTTP_RPC_URL =
  "https://base-mainnet.g.alchemy.com/v2/6GKxbi8Ws08Hj9DpzoG0w";

export const RPC_MAP: Record<NetworkType, string> = {
  testnet: BASE_SEPOLIA_HTTP_RPC_URL,
  mainnet: BASE_MAINNET_HTTP_RPC_URL,
};

export const RPC_URL = RPC_MAP[networkType];

export interface INetwork {
  chainId: number;
  chainName: string;
  rpcUrls: string[];
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  blockExplorerUrls: string[];
}

export const networkMap: Record<NetworkType, INetwork> = {
  testnet: {
    chainId: 84532,
    chainName: "Base Sepolia",
    rpcUrls: [BASE_SEPOLIA_HTTP_RPC_URL],
    nativeCurrency: {
      name: "Sepolia Ether",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://sepolia.basescan.org"],
  },
  mainnet: {
    chainId: 8453,
    chainName: "Base Mainnet",
    rpcUrls: [BASE_MAINNET_HTTP_RPC_URL],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://basescan.org"],
  },
};

export const EXCHANGE_RATE = 48.60368664;

export const TOKENOMICS_URL = "https://sphn.notion.site/Spheron-Tokenomics-23db2d6b832a80038e19f464d708059a";

// Check for traffic overload environment variable
export const isTrafficOverload =
  process.env.NEXT_PUBLIC_TRAFFIC_OVERLOAD === "true";